/**
 * AI 회의록 샘플(시연) 모드 스위치 — 화면에는 없다. 주소에 `?mn_demo=1` 을 붙여 열면 켜지고
 * `?mn_demo=0` 이면 꺼진다. 켠 상태는 **그 탭(sessionStorage)에만** 남아 화면을 옮겨 다녀도
 * 유지되고, 탭을 닫으면 사라진다.
 *
 * ★ 앱이 뜰 때 한 번 읽는다(src/index.tsx). 모달이 처음 마운트될 때만 읽으면,
 *   `/crm/leads?mn_demo=1` 로 들어와 리드를 여는 사이 주소가 바뀌어 파라미터가 사라진 뒤라
 *   켜지지 않는다(사용자 QA 2026-10-20).
 *
 * ★ 예전엔 헤더 토글 + 노란 안내 띠였고 켠 상태를 localStorage(`mn.flow.sample`)에 영구 기억했다.
 *   토글·띠를 숨기고 시연 화면에서 "샘플" 글자를 뺐으므로(사용자 요청 2026-10-20) 영구 기억하면
 *   예전에 켜 둔 사람이 모르는 채로 저장 안 되는 접수를 하게 된다. 옛 키는 지운다.
 */
const DEMO_PARAM = "mn_demo";
const DEMO_SESSION_KEY = "mn.flow.demo";
const LEGACY_SAMPLE_KEY = "mn.flow.sample";

/** 지금 주소의 `?mn_demo=` 를 탭 기억에 옮긴다. 앱 시작과 모달을 열 때 부른다. */
export function captureDemoParam(): void {
  try { window.localStorage.removeItem(LEGACY_SAMPLE_KEY); } catch { /* 못 지워도 읽지 않으니 그만 */ }
  try {
    const q = new URLSearchParams(window.location.search).get(DEMO_PARAM);
    if (q === "1") window.sessionStorage.setItem(DEMO_SESSION_KEY, "1");
    else if (q === "0") window.sessionStorage.removeItem(DEMO_SESSION_KEY);
  } catch { /* 기억 못 하면 꺼진 채로 둔다 */ }
}

/** 샘플 모드가 켜져 있는가. */
export function readDemoSwitch(): boolean {
  captureDemoParam();
  try { return window.sessionStorage.getItem(DEMO_SESSION_KEY) === "1"; } catch { return false; }
}
